import {useSupportActions} from "./hooks/useSupportActions";
import React from "react";
import {IconContact, IconLogout, IconSupport} from "../../../../bounce-ui/consumer";
import CustomMenuItem from "../../../../components/menus/CustomMenuItem";

const SupportOptions = () => {
  const {onLogout, onSupportClick, onManageContactClick, shouldDisplaySupportOptions} = useSupportActions();

  if (!shouldDisplaySupportOptions) return null;

  return (
    <>
      <CustomMenuItem
        label={"Manage contact details"}
        icon={<IconContact width={20} height={20} />}
        onClick={onManageContactClick}
      />
      <CustomMenuItem onClick={onSupportClick} label="Contact us" icon={<IconSupport width={20} height={20} />} />
      <CustomMenuItem onClick={onLogout} label="Log out" icon={<IconLogout width={20} height={20} />} />
    </>
  );
};

export default SupportOptions;
